






















































import { Prop } from 'vue-property-decorator';
import Component, { mixins } from 'vue-class-component';

import Mixin from '@/mixins/formatter';

import MultipleCheckBox from '@/components/Atoms/Input/MultipleCheckBox.vue';
import BasicModal from '@/components/Molecules/Modal/BasicModal.vue';
import ModalTextLink from '@/components/Atoms/Link/ModalTextLink.vue';

import { Option } from '@/data/hikari/option';

@Component({
  components: {
    MultipleCheckBox,
    BasicModal,
    ModalTextLink,
  },
})
export default class PhoneOption extends mixins(Mixin) {
  @Prop() phone_id!: string;
  @Prop() option!: Option;
  @Prop() index!: number;

  get optionAttentionNo(): string {
    if (this.phone_id === 'basic') {
      switch (this.option.id) {
        case 'number_request':
          return '*1';
        case 'number_block':
          return '*2';
        case 'auto_transfer':
          return '*3 *4';
        case 'call_notice_mail':
          return '*4';
        case 'fax_notice_mail':
          return '*2 *4';
        default:
          return '';
      }
    } else {
      return this.option.id === 'fax_notice_mail' ? '*1 *2' : '';
    }
  }
}
